import { CodeBlock } from "@/components/storyboard/code/CodeBlock";

interface QuizReviewCodeProps {
  userAnswer: string;
  language?: string;
}

/**
 * Code answer echo in quiz review — highlighted like everywhere else in the
 * course, since unformatted code is what the learner never wrote.
 */
const QuizReviewCode = ({ userAnswer, language }: QuizReviewCodeProps) => (
  <div className="w-full">
    <p className="mb-2 font-semibold uppercase tracking-wide text-muted-foreground">
      Dein Code
    </p>
    <CodeBlock code={userAnswer} defaultLanguage={language} />
  </div>
);

export default QuizReviewCode;
